import { axiosGet } from '@/app/helpers/AxiosHelper';

export default {
    state: {
        tags: [],
        versions: [],
        technicalManagers: [],
    },

    getters: {
        getTag: state => name => {
            let tag = '';
            if (state.tags.length > 0) {
                const tmp = state.tags.filter(item => {
                    const split = item.name.split('#');
                    if(split[1] == name) return item;
                });
                if(tmp.length > 0) tag = tmp[0].text;
            }
            return tag;
        },
        getVersions: state => name => {
            let tmp = [
                { id: null, value: "Seleccione una opción" },
              ];
              if(state.versions && state.versions.length > 0) {
                  tmp = [...tmp, ...state.versions];
              }
        
              return tmp;
        },
        getTechnicalManagers: state => name => {
            let tmp = [
                { id: null, value: "Seleccione una opción" },
              ];
              if(state.technicalManagers && state.technicalManagers.length > 0) {
                  tmp = [...tmp, ...state.technicalManagers];
              }
        
              return tmp;
        },
    },

    mutations: {
        SET_TAGS(state, data) {
            state.tags = data;
        },
        SET_VERSIONS(state, data) {
            state.versions = data;
        },
        SET_TECHNICAL_MANAGERS(state, data) {
            state.technicalManagers = data;
        },
    },

    actions: {
        getTags({ commit, state }, data) {
            state.tags = [];
            const url = `/accreditations/forms/tags/getByTab?accAppId=${data.accAppId}&tab=${data.tab}`;
            axiosGet(url).then(res => {
                if (res.status == 200) {
                    commit('SET_TAGS', res.data);
                }
            });
        },
        getTagsByActivity({ commit, state }, data) {
            state.tags = [];
            const url = `/accreditations/forms/tags/getByActivity?accAppId=${data.accAppId}`;
            axiosGet(url).then(res => {
                if (res.status == 200) {
                    commit('SET_TAGS', res.data);
                }
            });
        },
        getVersions({ commit, state }, data) {
            const url = '/accreditations/forms/versions/list';
            axiosGet(url).then(res => {
                if (res.status == 200) {
                    commit('SET_VERSIONS', res.data);
                }
            });
        },
        getTechnicalManagers({ commit, state }, data) {
            const url = 'accreditations/process/technicalManagers';
            axiosGet(url).then(res => {
                if (res.status == 200) {
                    commit('SET_TECHNICAL_MANAGERS', res.data);
                }
            });
        },
    }
}